'use client';

import React from 'react';

interface TemplateFiltersProps {
  selectedAge: string | null;
  selectedTheme: string | null;
  onAgeChange: (age: string | null) => void;
  onThemeChange: (theme: string | null) => void;
}

const AGE_BUCKETS = [
  { value: '0-2', label: '0-2 years' },
  { value: '3-4', label: '3-4 years' },
  { value: '5-6', label: '5-6 years' },
  { value: '7-8', label: '7-8 years' },
  { value: '9-10', label: '9-10 years' },
];

const THEMES = [
  { value: 'nature', label: '🌿 Nature' },
  { value: 'everyday', label: '🏠 Everyday Life' },
  { value: 'shapes', label: '⭐ Shapes' },
  { value: 'animals', label: '🐾 Animals' },
];

export default function TemplateFilters({
  selectedAge,
  selectedTheme,
  onAgeChange,
  onThemeChange,
}: TemplateFiltersProps) {
  return (
    <div className="mb-8 space-y-4">
      {/* Age Filter */}
      <div>
        <h3 className="mb-2 text-sm font-semibold text-gray-700">Age Range</h3>
        <div className="flex flex-wrap gap-2">
          <button
            onClick={() => onAgeChange(null)}
            className={`rounded-full px-4 py-2 text-sm font-medium transition-colors ${
              selectedAge === null
                ? 'bg-gradient-to-r from-green-500 to-lime-400 text-white'
                : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
            }`}
          >
            All Ages
          </button>
          {AGE_BUCKETS.map(age => (
            <button
              key={age.value}
              onClick={() => onAgeChange(age.value)}
              className={`rounded-full px-4 py-2 text-sm font-medium transition-colors ${
                selectedAge === age.value
                  ? 'bg-gradient-to-r from-green-500 to-lime-400 text-white'
                  : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
              }`}
            >
              {age.label}
            </button>
          ))}
        </div>
      </div>

      {/* Theme Filter */}
      <div>
        <h3 className="mb-2 text-sm font-semibold text-gray-700">Theme</h3>
        <div className="flex flex-wrap gap-2">
          <button
            onClick={() => onThemeChange(null)}
            className={`rounded-full px-4 py-2 text-sm font-medium transition-colors ${
              selectedTheme === null
                ? 'bg-gradient-to-r from-green-500 to-lime-400 text-white'
                : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
            }`}
          >
            All Themes
          </button>
          {THEMES.map(theme => (
            <button
              key={theme.value}
              onClick={() => onThemeChange(theme.value)}
              className={`rounded-full px-4 py-2 text-sm font-medium transition-colors ${
                selectedTheme === theme.value
                  ? 'bg-gradient-to-r from-green-500 to-lime-400 text-white'
                  : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
              }`}
            >
              {theme.label}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}

